export function formatPinnedFile(p) {
  return {
    address: p.Address,
    counter: p.PinCounter,
    raw: p.IsRaw,
    size: p.FileSize
  };
}
export function formatTag(t) {
  return {
    uid: t.Uid,
    name: t.Name,
    address: t.Address,
    total: t.Total,
    split: t.Split,
    seen: t.Seen,
    stored: t.Stored,
    sent: t.Sent,
    synced: t.Synced,
    startedAt: new Date(t.StartedAt)
  };
}
export function getGlobal() {
  // ES2020
  if (typeof globalThis !== 'undefined') {
    return globalThis;
  } // Browser window


  if (typeof window !== 'undefined') {
    return window;
  } // Web Worker


  if (typeof self !== 'undefined') {
    return self;
  }

  throw new Error('Unable to get global object');
}
export function getGlobalFetch() {
  var global = getGlobal();
  return global.fetch.bind(global);
}
export function toSwarmHash(buffer) {
  return Buffer.from(new Uint8Array(buffer)).toString('hex');
}